import React, { FC } from 'react';
import { IonPage, isPlatform, useIonViewWillEnter } from '@ionic/react';
import { Container_v2 as Container, Spinner_v2 as Spinner } from '@mindly/ui-components';
import { RouteComponentProps } from 'react-router';
import { fetchSpecialistBySlug } from '../../redux/loadedSpecialists/thunk';
import { useDispatch, useSelector } from 'react-redux';
import { PrivateRoutes, PublicRoutes } from '../../routes/navigation';
import { useAuthFlow } from '../../shared';
import { setRedirectTo } from '../../redux/auth/reducer';
import useLangs from '../../context/LangsContext';
import { specialistsFiltersLoadingSelector } from 'src/redux/specialists/selector';
import { fetchSpecialistsFilters } from 'src/redux/specialists/thunk';
import { useTranslation } from 'react-i18next';
import { useFeatureIsOn } from '@growthbook/growthbook-react';

const SpecialistProfileBySlug: FC<RouteComponentProps<{ slug: string }>> = ({ match, history }) => {
  const { slug } = match.params;
  const dispatch = useDispatch();
  const { authUser } = useAuthFlow();
  const { changeLocale } = useLangs();
  const loadingFiltersState = useSelector(specialistsFiltersLoadingSelector);
  const { t } = useTranslation('ui');
  const isLocalizedAreasOfWorkByClientProblem = useFeatureIsOn('localized_areas_of_work_by_client_problem');

  useIonViewWillEnter(async () => {
    try {
      if (/^[a-zA-Z0-9]{6}$/.test(slug)) {
        if (loadingFiltersState === 'idle') {
          try {
            await dispatch(fetchSpecialistsFilters({ t, isLocalizedAreasOfWorkByClientProblem })).unwrap();
          } catch (error) {
            console.log(error);
          }
        }
        const specData = await dispatch(fetchSpecialistBySlug(slug)).unwrap();

        if (specData && !localStorage.getItem('mindlyLocale')) {
          changeLocale(specData.app_lang);
        }

        if (specData && !authUser) {
          dispatch(setRedirectTo(PrivateRoutes.PSYCHOLOGIST_PROFILE.replace(':id', specData.id)));
        }

        if ((specData && authUser) || (specData && !authUser && !isPlatform('hybrid'))) {
          history.replace(PrivateRoutes.PSYCHOLOGIST_PROFILE.replace(':id', specData.id));
          return;
        }
      }

      if (!authUser) {
        history.replace(PublicRoutes.AUTH);
      } else {
        history.replace(PrivateRoutes.PSYCHOLOGIST_LIST);
      }
    } catch (e) {
      history.replace(PublicRoutes.AUTH);
    }
  }, [slug, loadingFiltersState, t]);

  return (
    <IonPage>
      <Container isFlexContainer>
        <div className={'flex flex-1 items-center justify-center'}>
          <Spinner size={48} />
        </div>
      </Container>
    </IonPage>
  );
};

export default SpecialistProfileBySlug;
